import { gql } from '@apollo/client'

import { FileFragment } from './file.fragment'
import { ProjectContactFragment } from './project-contact.fragment'
import { UserFragment } from './user.fragment'

export const ProjectFileFragment = gql`
  fragment ProjectFileFragment on ProjectFile {
    id
    createdDate
    updatedDate
    name
    description
    xfdf
    type
    file {
      ...FileFragment
    }
    url
    author {
      ...UserFragment
    }
    folderId
    zoneId
    zone {
      id
      name
    }
    status
    validationRequest {
      id
      createdDate
      updatedDate
      status
      validationUsers {
        id
        createdDate
        updatedDate
        status
        user {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
  ${FileFragment}
  ${UserFragment}
`

export const ProjectFolderFragment = gql`
  fragment ProjectFolderFragment on ProjectFolder {
    id
    createdDate
    updatedDate
    name
    description
    type
    author {
      ...UserFragment
    }
    projectId
    parentId
    isReadableByRoleProjectQRCode
    authorizedRole
    loggedUserRole
  }
  ${UserFragment}
`

export const ProjectFragment = gql`
  fragment ProjectFragment on Project {
    id
    createdDate
    updatedDate
    name
    companyName
    trialPeriodStartDate
    trialPeriodEndDate
    isTrialPeriodExpired
    authorId
    author {
      ...UserFragment
    }
    photos {
      ...ProjectFileFragment
    }
    contacts {
      ...ProjectContactFragment
    }
  }
  ${UserFragment}
  ${ProjectFileFragment}
  ${ProjectContactFragment}
`
